<app-nav-bar [svg]="true"></app-nav-bar>
<!--<app-bread-crumb title="Ubicación"></app-bread-crumb>-->
<agm-map (zoomChange)="setParams($event)" *ngIf="latitude && longitude" [zoom]="zoom" [latitude]="latitude" [longitude]="longitude">
  <agm-marker [latitude]="latitude" [longitude]="longitude"></agm-marker>
</agm-map>
